import PriceJumpTrackingService, { TpriceJump } from '@ve/services/analytics/yandexAnalytics/PriceJumpTrackingService';

interface IgetTrackHotelJumpPriceData {
    priceJumpType: TpriceJump
    shouldTrackingPriceJump: boolean
}

interface ItrackJumpHotelPageBetweenCacheAndSearch {
    shouldTrackPriceJump: boolean
    priceJumpType?: string
    priceJumpValue?: number
    goalParams?: Record<string, any>,
}

export default class HotelPagePriceJumpTrackingService extends PriceJumpTrackingService {
    public shouldTrackHotelJumpPriceBetweenCacheAndFullSearch = true;

    public toursMinPriceFromCache = 0;

    allowTrackHotelJumpCacheAndSearch(): void {
        this.shouldTrackHotelJumpPriceBetweenCacheAndFullSearch = true;
    }

    clearCachePrice(): void {
        this.toursMinPriceFromCache = 0;
    }

    setTourMinPriceFromCache(price: number): void {
        if (typeof price !== 'number') {
            return;
        }
        this.toursMinPriceFromCache = price;
    }

    getTrackHotelJumpPriceData(hotelMinPrice: number, serpMinPrice: number): IgetTrackHotelJumpPriceData {
        const {
           priceJumpType,
           priceJumpValue,
       } = this.getPriceJump(serpMinPrice, hotelMinPrice);

       const shouldTrackingPriceJump = priceJumpValue > 500;

       return {
           priceJumpType,
           shouldTrackingPriceJump,
       };
   }

   trackJumpHotelPageBetweenCacheAndSearch(fullSearchPrice: number): ItrackJumpHotelPageBetweenCacheAndSearch {
        if (!this.shouldTrackHotelJumpPriceBetweenCacheAndFullSearch
            || !this.toursMinPriceFromCache
        ) {
            return {
                shouldTrackPriceJump: false,
            };
        }

        this.shouldTrackHotelJumpPriceBetweenCacheAndFullSearch = false;

        const {
            shouldTrackPriceJump,
            priceJumpType,
            priceJumpValue,
            goalParams,
        } = this.trackJumpPrice(
                this.toursMinPriceFromCache,
                fullSearchPrice,
                'hotel_cache_hotel_actual',
            );

        return {
            shouldTrackPriceJump,
            priceJumpType,
            priceJumpValue,
            goalParams,
        };
   }
}